module.exports = __webpack_public_path__ + "img/hdmd1.dc6b9705.jpg";